import HttpRequest from '@/config/axios.config'
import i18n from '@/config/translation'
import { isEmptyValue } from '@/utils/common'

export async function loadLocalizationData() {
  const localization = await HttpRequest.get('/translations/web/en')
  const localizationData = localization.data.data
  const enLocalization = {}
  localizationData.forEach((element: any) => {
    enLocalization[element.code] = !isEmptyValue(element?.translation_customs)
      ? element?.translation_customs[0].translation
      : element?.translation
  })
  i18n.addResourceBundle('en', 'translation', enLocalization)
}
